module.exports = __webpack_public_path__ + "static/media/innov.615c7048.jpg";